import React from 'react';
import classes from './MyLoader.module.css'

function MyLoader(props) {
    return (
        <div className={classes.loader}>

        </div>
    );
}

export default MyLoader;